
import { IonPage, IonHeader,IonButton  } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { defineComponent } from 'vue';
import Testing from '@/components/Testing.vue';

export default defineComponent({
  name: 'recommended',
  components: {IonHeader, IonPage,IonButton, Testing },
  setup() { 
    const router = useRouter();
    return {router};
  },
  created: function(){
      this.isLogin();
  },
  

  methods:{
    isLogin(){
      if(localStorage.getItem('accesstoken') === null){
        localStorage.clear();
        this.router.push('/app');
      }     
    },
    logout(){
        
        localStorage.setItem('player-link', "playlist/37i9dQZEVXbMDoHDwVN2tF?si=zUE-_fHXQN-d4IEWcFhKqg")
      window.dispatchEvent(new CustomEvent('player-link-localstorage-changed', {
        detail: {
          storage: localStorage.getItem('player-link')
        }
      }));
      localStorage.clear();
        this.router.push('/app');  
    },

    }
});




